export const trendingCategory: Record<string, string> = {
  trending: 'Trending',
  most_read: 'Most Read',
  lastest_topics: 'Latest News',
  news_events: 'News or Events',
}
